import type { RegionKey, USState } from '../types';

export interface RegionMeta {
  key: RegionKey;
  state: USState;
  title: string;
  shortTitle: string;
  subtitle: string;
  mood: string;
  accent: string;
  bestFor: string[];
}

export const REGIONS: RegionMeta[] = [
  {
    key: 'dripping-springs-fitzhugh',
    state: 'TX',
    title: 'Dripping Springs & Fitzhugh Road',
    shortTitle: 'Dripping Springs',
    subtitle:
      'The polished Hill Country chapter: orchard tastings, sommelier-style classes, and the easiest luxury-stay pairing on the route.',
    mood: 'Limestone roads, vineyard energy, and a polished weekend pace.',
    accent: 'Olive green, limestone, warm cream',
    bestFor: ['Guided tastings', 'Weekend luxury', 'Food-focused travelers', 'First-time olive routes'],
  },
  {
    key: 'new-braunfels-gruene',
    state: 'TX',
    title: 'New Braunfels & Historic Gruene',
    shortTitle: 'Gruene',
    subtitle:
      'Retail tastings and river-town stays anchored by one of the easiest olive detours to fold into a Texas weekend.',
    mood: 'Historic district walks, river hotels, and casual tasting-room stops.',
    accent: 'River blue, weathered wood, pale gold',
    bestFor: ['River weekends', 'Walkable districts', 'Shopping + tasting', 'Couples getaways'],
  },
  {
    key: 'central-texas-detours',
    state: 'TX',
    title: 'Central Texas Orchard Detours',
    shortTitle: 'Central Texas',
    subtitle:
      'The practical expansion loop: working orchards north and east of Austin that reward travelers willing to leave the main Hill Country corridor.',
    mood: 'Backroad farming, lower-key visits, and producer-first stops.',
    accent: 'Dusty green, copper, sunlit tan',
    bestFor: ['Producer visits', 'Long weekends', 'Austin add-ons', 'Repeat visitors'],
  },
  {
    key: 'santa-fe-plaza',
    state: 'NM',
    title: 'Santa Fe Plaza Tasting Rooms',
    shortTitle: 'Santa Fe',
    subtitle:
      'A high-desert urban chapter built around walkable tasting rooms, culinary shopping, and Plaza-adjacent boutique stays.',
    mood: 'Adobe streets, gourmet browsing, and tasting-room conversations.',
    accent: 'Adobe clay, chile red, pale sage',
    bestFor: ['Walkable weekends', 'Food shopping', 'Santa Fe first-timers', 'Short tastings'],
  },
  {
    key: 'albuquerque-corrales',
    state: 'NM',
    title: 'Albuquerque & Corrales',
    shortTitle: 'Albuquerque',
    subtitle:
      'A practical New Mexico extension with tap-room style olive sampling, classes, and an easier urban base than Santa Fe.',
    mood: 'Everyday culinary retail, local classes, and lower-key city pacing.',
    accent: 'Pinon, sandstone, muted gold',
    bestFor: ['Local classes', 'Tap-room browsing', 'Road-trip overnight', 'Budget-flexible travel'],
  },
  {
    key: 'queen-creek-phoenix',
    state: 'AZ',
    title: 'Queen Creek & Greater Phoenix',
    shortTitle: 'Queen Creek',
    subtitle:
      'Arizona’s strongest olive chapter: the working mill in Queen Creek paired with Phoenix-area tasting rooms and stronger metro stay options.',
    mood: 'Desert light, agritourism energy, and polished metro overnights.',
    accent: 'Desert olive, terracotta, sun wash',
    bestFor: ['Working mill tours', 'Phoenix weekends', 'First Arizona olive trip', 'Stay-led planning'],
  },
];

export function getRegion(key: RegionKey): RegionMeta | undefined {
  return REGIONS.find((region) => region.key === key);
}
